import { FC } from 'react';
import { Body2, MessageBar, MessageBarBody, Subtitle1 } from '@fluentui/react-components';
import { AddRegular, StorageRegular, SubtractRegular } from '@fluentui/react-icons';

import { FILES_WITH_ISSUES_MOCK_DATA, TOP_CARDS_MOCK_DATA } from '../complianceDashboard.constants';

import StatCard, { NumberPreview } from '../components/StatCard';
import CircularProgress from '../components/CircularProgress';
import ComplianceIssuesTable from '../components/ComplianceIssuesTable';
import { DateLabel } from '@shared/components';

const ComplianceDashboard: FC = () => {
  // Current date + 30 days
  const deadlineDate = new Date(new Date().setDate(new Date().getDate() + 30)).toISOString();

  return (
    <div className="grow h-full w-full relative">
      <div className="absolute top-0 left-0 w-full h-full overflow-y-auto flex items-center justify-center">
        <div className="mt-4 max-w-screen-xl flex flex-col gap-12 h-full">
          {/* <div className="flex flex-col gap-12 w-full h-full"> */}
          {/* Title Section */}
          <div className="flex justify-between w-full">
            <div className="flex flex-col gap-1 w-fit">
              <Subtitle1>Compliance dashboard</Subtitle1>
              <Body2>Ivexis - EU IVDR 2017/746</Body2>
            </div>
            <div className="h-fit">
              <MessageBar intent={'info'}>
                <MessageBarBody>
                  {/* <MessageBarTitle>Title</MessageBarTitle> */}
                  Preparation deadline was set to{' '}
                  <strong>
                    <DateLabel children={deadlineDate} />
                  </strong>
                  {/* <Link>Link</Link> */}
                </MessageBarBody>
              </MessageBar>
            </div>
          </div>

          {/* Top row of “cards” */}
          <div className="flex gap-12 justify-center">
            {/* Submission Readiness Card */}
            <StatCard
              title="Progress"
              tooltip="The percentage of documents and files that are ready for submission."
              infoButtonColor="green"
              preview={<CircularProgress percentage={TOP_CARDS_MOCK_DATA.submissionReadiness} />}
              footerBadgeIcon={<StorageRegular fontSize="16px" fontWeight="800" />}
              footerBadgeText={`${TOP_CARDS_MOCK_DATA.totalDocuments} total`}
              footerSubtitle="documents & files"
              badgeColor="informative"
            />

            {/* Critical Issues Card */}
            <StatCard
              title="Critical issues"
              tooltip="The number of critical issues that need to be resolved before submission."
              infoButtonColor="green"
              preview={
                <NumberPreview
                  colorSchemeKey="danger"
                  value={TOP_CARDS_MOCK_DATA.criticalIssues}
                  subtitle="unresolved issues"
                />
              }
              footerBadgeIcon={<SubtractRegular fontWeight="800" />}
              footerBadgeText={`${TOP_CARDS_MOCK_DATA.criticalIssuesLess} issues`}
              footerSubtitle="since last week"
              footerBadgeClassName="!bg-brand-160 flex items-center !py-2 gap-1"
              badgeColor="success"
            />

            {/* Open Approvals Card */}
            <StatCard
              title="Open approvals"
              tooltip="The number of approvals that are still pending."
              infoButtonColor="green"
              preview={
                <NumberPreview
                  colorSchemeKey="info"
                  value={TOP_CARDS_MOCK_DATA.openApprovals}
                  subtitle="pending approvals"
                />
              }
              footerBadgeIcon={<AddRegular fontWeight="800" />}
              footerBadgeText={`${TOP_CARDS_MOCK_DATA.openApprovalsMore} files`}
              footerSubtitle="since last week"
              footerBadgeClassName="!bg-brand-160 flex items-center !p-1 gap-1"
              badgeColor="warning"
            />
          </div>

          <ComplianceIssuesTable items={FILES_WITH_ISSUES_MOCK_DATA} />
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default ComplianceDashboard;
